import React, { useState, useEffect } from "react";
import Sidebar from "../src/Components/Sidebar";
import Layout from "./layout/Layout";
// import DataTable from "react-data-table-component";
import DataTable from "./Components/DataTable";
import "./index.css";
import CodeManagementTable from "./Components/CodeManagament/CodeManagementTable";
//import CodeManagementForm from "./Components/CodeManagament/CodeManagementForm";
import AddPromoModal from "./Components/CodeManagament/AddPromoModal";
import { useQuery, gql } from "@apollo/client";
import Loader from "./Loader";
import CodeManagementForm from "./Components/CodeManagament/CodeManagementForm";
const GET_PROMOCODE = gql`
  query {
    getPromocode {
      status
      message
      promoCodeList {
        id
        name
        promocode
        discount
        type
        gender
        description
        users
        minOrder
        maxDiscount
        orderNo
        validFrom
        validTo
        serviceId
        isPercentage
        isActive
        hide
        isServicePromo
        userIds
        campaignCode
        newUsersOnly
        maxUsagesPerUser
        walletCreditAmount
        walletCreditPercent
        walletCreditCap
        autoGrantEnabled
      }
    }
  }
`;
const CodeManagement = () => {
  const { data, loading, error } = useQuery(GET_PROMOCODE);
  const [dataList, setDataList] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [isFetched, setIsFetched] = useState(false);

  useEffect(() => {
    try {
      setDataList(data.getPromocode.promoCodeList);
      setIsFetched(true);
    } catch (err) {
      console.log(err);
    }
  }, [data]);
  if (loading) return <Loader />;
  return (
    <>
      {isFetched && (
        <div className="min-h-screen flex">
          <Sidebar />
          <Layout>
            {openModal ? (
              <CodeManagementForm setEditCodeManagementForm={setOpenModal} />
            ) : (
              <CodeManagementTable
                data={dataList}
                setOpenModal={setOpenModal}
              />
            )}
          </Layout>
        </div>
      )}
    </>
  );
};

export default CodeManagement;
